import { useEffect, useState } from 'react'

type TimeLeft = {
  hours: number
  minutes: number
  seconds: number
}

function computeTimeLeft(target: number): TimeLeft {
  const diff = Math.max(0, target - Date.now())
  const totalSeconds = Math.floor(diff / 1000)
  return {
    hours: Math.floor(totalSeconds / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
  }
}

export function useCountdown(durationHours = 24): TimeLeft {
  const [target] = useState(() => Date.now() + durationHours * 60 * 60 * 1000)
  const [timeLeft, setTimeLeft] = useState(() => computeTimeLeft(target))

  useEffect(() => {
    const id = window.setInterval(() => setTimeLeft(computeTimeLeft(target)), 1000)
    return () => window.clearInterval(id)
  }, [target])

  return timeLeft
}
